<template>
    <div class="home" v-loading="loading">
        <div class="swiper-slide">
            <div class="page" v-if="language == 'ZH'">
                <h3>{{ $t('h.MainBusiness') }}</h3>
                <div>
                    <span class="left">一</span>
                    <p class="right">
                        <span>订</span><span>场</span><span style="font-size:28px;">·</span><span>旅</span><span>游</span>
                    </p>
                </div>
                <div>
                    <span class="left">二</span>
                    <p class="right">
                        <span>会</span><span>籍</span><span>代</span><span>理</span>
                    </p>
                </div>

                <div>
                    <span class="left">三</span>
                    <p class="right"> <span>赛</span><span>事</span><span>承</span><span>办</span></p>
                </div>
                <div>
                    <span class="left">四</span>
                    <p class="right"> <span>高</span><span>尔</span><span>夫</span><span>商</span><span>城</span></p>
                </div>
                <div>
                    <span class="left">五</span>
                    <p class="right">
                        <span>新</span><span>媒</span><span>体</span>
                    </p>
                </div>
            </div>
            <div class="page" v-else>
                <h3 style="letter-spacing: 0;">{{ $t('h.MainBusiness') }}</h3>
                <div>
                    <span style="letter-spacing: 0;">Tee time booking & Golf travel</span>
                </div>
                <div>
                    <span style="letter-spacing: 0;">Membership sales & Transaction</span>
                </div>
                <div>
                    <span style="letter-spacing: 0;">Golf event organisation</span>
                </div>

                <div>
                    <span style="letter-spacing: 0;">Golf pro shop</span>
                </div>
                <div>
                    <span style="letter-spacing: 0;">Advertising media PR</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    name: "HelloWorld",
    components: {
        swiper,
        swiperSlide,

    },
    data() {
        return {
            loading: true,
            caseList: [],
            newsList: [],
            language: localStorage.getItem("lang") || "ZH"
        };
    },
    created() { },
    mounted() {
        this.language = localStorage.getItem("lang") || "ZH"
        this.loading = false;
    },
};
</script>

<style scoped>
.swiper-slide {
    width: 100%;
    font-size: 24px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10rem;
}

.swiper-slide .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -7.5rem;
}

.swiper-slide .page h3 {
    font-size: 2.5rem;
    letter-spacing: 2rem;
    margin-left: 1rem;
}

.swiper-slide .page div {
    text-align: left;
    overflow: hidden;
    font-size: 1.5rem;
    letter-spacing: 1.5rem;
    margin-top: 1.5rem;
    display: flex;

}

.swiper-slide .page div .left {
    letter-spacing: 0px;
    margin-right: 2.5rem;
}

.swiper-slide .page div .right {
    width: 15rem;
    display: flex;
    justify-content: space-between;
}

.case-item {
    width: 1100px;
    height: 500px;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.case-item .li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;
}

.case-item .li:hover .case-item-hover {
    opacity: 1;
    transition: all 0.4s ease-in-out;
}

.case-item-hover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    overflow: hidden;
    background-color: rgba(225, 56, 52, 0.7);
}

.case-item-hover .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
}

.case-item-hover .more span {
    color: #fff;
    font-size: 20px;
}

.case-item-hover .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
}

.case-item-hover .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
}

/* //最新资讯
// .news-content {
//     width: 1240px;
//     margin: 0 auto;
//     margin-top: 40px;
//     display: flex;
//     justify-content: center;

//     &-item {
//         width: 400px;
//         display: flex;
//         flex-direction: column;

//         .item-img {
//             width: 360px;
//             height: 230px;
//             background-repeat: no-repeat;
//             background-size: cover;
//             background-position: center;
//             background-origin: content-box;
//             margin: 0 auto;
//         }
//         .el-divider {
//             background-color: #fff;
//             height: 3px;
//             .el-divider__text {
//                 width: 20px;
//                 height: 20px;
//                 border-radius: 50%;
//                 padding: 0px;
//                 color: #fff;
//             }
//         }
//         .item-content {
//             width: 360px;
//             height: 230px;
//             margin: 0 auto;
//             h3 {
//                 font-size: 30px;
//                 height: 30px;
//                 overflow: hidden;
//                 text-overflow: ellipsis;
//                 white-space: nowrap;
//             }
//             p {
//                 font-size: 10px;
//                 height: 80px;
//                 overflow: hidden;
//                 margin: 10px 0;
//                 text-overflow: ellipsis;
//                 display: -webkit-box;
//                 -webkit-line-clamp: 4;
//                 -webkit-box-orient: vertical;
//                 white-space: normal !important;
//                 word-wrap: break-word;
//             }
//             span {
//                 display: block;
//                 font-size: 14px;
//                 text-align: end;
//             }
//             h3,
//             p,
//             span {
//                 color: #fff;
//             }
//         }
//     }
// } */
.order {
    order: -1;
}

.order-img {
    order: 1;
}
</style>